<div class="services-panel">
  <div class="services-panel__header ngkit-flex-container-row">
    <div class="services-panel__title-block">
      <span class="services-panel__explore ngkit-text-caption">Explore</span>
      <h3 class="services-panel__title">Services</h3>
    </div>
  </div>

  <div class="services-panel__search">
    <ngkit-search
      class="ngkit-width-full"
      placeholder="Find a service"
      [prepopulatedSearchQuery]="filterText()"
      (searchUpdated)="onSearch($event)"
      (searchCleared)="clearSearch()"
    />
  </div>

  @if (loading()) {
    <div class="services-panel__state services-panel__state--loading" role="status">Loading services...</div>
  } @else if (error()) {
    <div class="services-panel__state services-panel__state--error" role="status">
      Failed to load services
      <div class="services-panel__error">{{ error() }}</div>
    </div>
  } @else if (services().length === 0) {
    <div class="services-panel__state services-panel__state--empty" role="status">No services</div>
  } @else if (hasNoMatches()) {
    <div class="services-panel__state services-panel__state--no-results" role="status">
      No services match your search.
    </div>
  } @else {
    <ul class="services-panel__items" role="listbox" aria-label="Services">
      @for (service of filteredServices(); track service.client_id) {
        <li class="services-panel__item" role="presentation">
          <button
            type="button"
            class="services-panel__row"
            [class.is-active]="service.client_id === selectedId()"
            [attr.data-client-id]="service.client_id"
            role="option"
            [attr.aria-selected]="service.client_id === selectedId()"
            [attr.tabindex]="service.client_id === focusableId() ? 0 : -1"
            (click)="onSelect(service.client_id)"
            (keydown)="onOptionKeydown($event)"
          >
            <span class="services-panel__details">
              <span
                class="services-panel__name text-truncate"
                [fgaEllipsisTitle]="service.name"
              >{{ service.name }}</span>
            </span>
          </button>
        </li>
      }
    </ul>
  }
</div>
